/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH
 * @see PROJECT_LICENSE.txt
 */

import { v4 as uuidv4 } from "uuid";

/**
 * Generates headers for Magento API requests
 */
const getHeaders = () => ({
    "Magento-Environment-Id": window.liveSearchConfig.environmentId,
    "Magento-Website-Code": window.liveSearchConfig.websiteCode,
    "Magento-Store-Code": window.liveSearchConfig.storeCode,
    "Magento-Store-View-Code": window.liveSearchConfig.storeViewCode,
    "X-Api-Key": window.liveSearchConfig.apiKey,
    "X-Request-Id": uuidv4(),
    "Content-Type": "application/json",
    // "Magento-Customer-Group": config.customerGroup,
});

/**
 * Executes a product search via the Magento GraphQL API
 *
 * @param {string} url - API endpoint
 * @param {string} query - GraphQL query string
 * @param {Object} options - Variables for the query
 * @param {Function} errorHandler - Callback for error handling
 * @returns {Promise<Object|undefined>} API response data or undefined on error
 */
const productSearch = async (url, query, options, errorHandler) => {
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ query, variables: options })
        });

        const results = await response.json();

        if (results.errors?.length) {
            results.errors.forEach(err => { throw new Error(err.message); });
        }

        return results?.data;
    } catch (error) {
        errorHandler(error);
    }
};

/**
 * Returns the gender filter label based on the selected state or cookie
 *
 * @param {string|null} type - Optional filter type
 * @returns {string} Gender filter label
 */
const getGenderFilter = (type = null) => {
    const store = Alpine.store("genderToggle");
    const labels = window.liveSearchConfig.departmentFilterLabels;

    if (type === "gender" || store?.used) {
        return store?.checked ? labels.men : labels.women;
    }

    return hyva.getCookie("mey-gender") === "m" ? labels.men : labels.women;
};

export {
    productSearch,
    getHeaders,
    getGenderFilter
};
